import React from 'react'
import './About.css'
export default function About() {
    return (
        <div className='about-container'>
            <div className="content">
                <h3>About Me</h3>
                <div className='golden-bar'></div>
                <div className="about-container-bottom">
                    <div className="text">
                        <p>I’m a Frontend developer from Nowshera, Pakistan working in web development. I enjoy turning complex problems into simple, beautiful and intuitive designs.</p>
                        <p>My job is to build websites so that it is functional and user-friendly but at the same time attractive. Moreover, I add personal touch to your product and make sure that is eye-catching and easy to use. My aim is to bring across your message and identity in the most creative way.</p>
                    </div>
                    <h3>What I'm Doing</h3>
                    <div className="cards">
                        <div className="card">
                            <div className="doing-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-layout-text-window-reverse" viewBox="0 0 16 16">
                                    <path d="M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z" />
                                    <path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1zM1 4v10a1 1 0 0 0 1 1h2V4zm4 0v11h9a1 1 0 0 0 1-1V4z" />
                                </svg>
                            </div>
                            <div className='doing'>
                                <h5 className='doing-title'>web desing</h5>
                                <p className='doing-desc'>The most modern and high-quality design made at a professional level</p>
                            </div>
                        </div>
                        <div className="card">
                            <div className="doing-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
                                    <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0" />
                                </svg>
                            </div>
                            <div className='doing'>
                                <h5 className='doing-title'>web developer</h5>
                                <p className='doing-desc'>The most modern and high-quality design made at a professional level</p>
                            </div>
                        </div>
                        <div className="card">
                            <div className="doing-icon">
                                {/* For the svg */}
                            </div>
                            <div className='doing'>
                                <h5 className='doing-title'>{/*for the title*/}</h5>
                                <p className='doing-desc'>To be added soon...</p>
                            </div>
                        </div>
                        <div className="card">
                            <div className="doing-icon">
                                {/* For the svg */}
                            </div>
                            <div className='doing'>
                                <h5 className='doing-title'>{/*for the title*/}</h5>
                                <p className='doing-desc'>To be added soon...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
